<template>
  <div class="train">
    <Header></Header>
    <div class="train-banner flex-row">
      <div class="container business-banner-title">
        <p>产业人才培训</p>
        <p>
          集团旗下上海浦东科苑培训中心打造产业商学院，培养新型产业运营和企业
        </p>
        <p>管理人才。</p>
      </div>
    </div>
    <div class="train-future">
      <p class="future-title">认知改变未来 研习提升高度</p>
      <p class="future-subtitle">已为来自10多个省市、3000多位政府人员和企业家提供人才定向培训服务</p>
      <div class="container flex-row future-list">
        <div class="future-item flex-col wow animate__animated animate__fadeInUp" data-wow-delay=".1s" data-wow-offset="0">
          <img width="120" src="@/assets/images/business/future-1.png" alt="">
          <p>实证案例教学</p>
        </div>
        <div class="future-item flex-col wow animate__animated animate__fadeInUp" data-wow-delay=".2s" data-wow-offset="0">
          <img width="120" src="@/assets/images/business/future-2.png" alt="">
          <p>情景模拟相结合</p>
        </div>
        <div class="future-item flex-col wow animate__animated animate__fadeInUp" data-wow-delay=".3s" data-wow-offset="0">
          <img width="120" src="@/assets/images/business/future-3.png" alt="">
          <p>定制化课程设计</p>
        </div>
        <div class="future-item flex-col wow animate__animated animate__fadeInUp" data-wow-delay=".4s" data-wow-offset="0">
          <img width="120" src="@/assets/images/business/future-4.png" alt="">
          <p>实战型权威师资</p>
        </div>
      </div>
    </div>
    <div class="train-lesson">
      <p class="lesson-title">特色课程</p>
      <div class="container" style="position:relative">
        <img @click="prevLesson" style="left:-90px;top:200px;position:absolute;cursor: pointer;" src="@/assets/images/aboutUs/left-arrow.png" alt="">
        <img @click="nextLesson" style="right:-90px;top:200px;position:absolute;cursor: pointer;"  src="@/assets/images/aboutUs/right-arrow.png" alt="">
        <el-carousel ref="carouselLesson" indicator-position="none" arrow="never" height="400px" type="card" :autoplay='false'>
          <el-carousel-item>
            <div class="lesson-item flex-row">
              <div>
                <p>新时代招商引资实务及招商干部能力提升高级研修班</p>
                <p>通过研习使政府招商从业人员整体深化产业认知，提升招商引资水平</p>
                <br/><br/>
                <img src="@/assets/images/business/number-01.png" alt="">
              </div>
              <img src="@/assets/images/business/lesson-1.png" alt="">
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="lesson-item flex-row">
              <div>
                <p>产业转型升级与园区创新发展研修班</p>
                <p>全链条解读产业和园区经济，有效提升各地方的招商引资和产业运营能力。</p>
                <br/><br/>
                <img src="@/assets/images/business/number-02.png" alt="">
              </div>
              <img src="@/assets/images/business/lesson-2.png" alt="">
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="lesson-item flex-row">
              <div>
                <p>企业转型与创新发展专题班</p>
                <p>学习企业转型方法论，助力企业提升价值创造能力，强化核心竞争力。</p>
                <br/><br/><br/>
                <img src="@/assets/images/business/number-03.png" alt="">
              </div>
              <img src="@/assets/images/business/lesson-3.png" alt="">
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="train-Advantage">
      <h1>核心优势</h1>
      <div class="advantage-list flex-row container">
        <div
          class="case-item"
          :class="currentCase==0?'case-active':''"
          @mouseover="currentCase=0"
          :style="'background-image:url('+require('@/assets/images/business/advantage5.png')"
        >
          <div>
            <div class="case-title">服务优势</div>
            <p>
              挖掘集团合作伙伴在产业投资、区域招商、园区建设运营等方面的实践经验，为政府、企业需求提供针对性培训服务。
            </p>
          </div>
        </div>
        <div
          class="case-item"
          :class="currentCase==1?'case-active':''"
          @mouseover="currentCase=1"
          :style="'background-image:url('+require('@/assets/images/business/advantage2.png')"
        >
          <div>
            <div class="case-title">课程优势</div>
            <p>
              挖掘集团合作伙伴在产业投资、区域招商、园区建设运营等方面的实践经验，为政府、企业需求提供针对性培训服务。
            </p>
          </div>
        </div>
        <div
          class="case-item"
          :class="currentCase==2?'case-active':''"
          @mouseover="currentCase=2"
          :style="'background-image:url('+require('@/assets/images/business/advantage4.png')"
        >
          <div>
            <div class="case-title">资源优势</div>
            <p>
              挖掘集团合作伙伴在产业投资、区域招商、园区建设运营等方面的实践经验，为政府、企业需求提供针对性培训服务。
            </p>
          </div>
        </div>
        <div
          class="case-item"
          :class="currentCase==3?'case-active':''"
          @mouseover="currentCase=3"
          :style="'background-image:url('+require('@/assets/images/business/advantage1.png')"
        >
          <div>
            <div class="case-title">基地优势</div>
            <p>
              挖掘集团合作伙伴在产业投资、区域招商、园区建设运营等方面的实践经验，为政府、企业需求提供针对性培训服务。
            </p>
          </div>
        </div>
        <div
          class="case-item"
          :class="currentCase==4?'case-active':''"
          @mouseover="currentCase=4"
          :style="'background-image:url('+require('@/assets/images/business/advantage3.png')"
        >
          <div>
            <div class="case-title">空间优势</div>
            <p>
              挖掘集团合作伙伴在产业投资、区域招商、园区建设运营等方面的实践经验，为政府、企业需求提供针对性培训服务。
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="train-case">
      <div class="container">
        <p class="case-title">培训案例</p>
        <div class="container" style="position:relative">
          <img
            v-if="caseList[1]"
            @click="prevCase"
            style="left:-90px;top:240px;position:absolute;cursor: pointer;"
            src="@/assets/images/aboutUs/left-arrow.png"
            alt=""
          />
          <img
            v-if="caseList[1]"
            @click="nextCase"
            style="right:-90px;top:240px;position:absolute;cursor: pointer;"
            src="@/assets/images/aboutUs/right-arrow.png"
            alt=""
          />
          <el-carousel
            ref="carouselCase"
            arrow="never"
            height="610px"
            :autoplay="false"
            indicator-position="none"
          >
            <el-carousel-item v-for="(i, index) in caseList" :key="index">
              <div class="flex-row case-list">
                <div v-for="(j, jdx) in i" :key="jdx">
                  <div class="shadow flex-col">
                    <div>学员：{{j.guest}}</div>
                    <div>规模：{{j.number}}</div>
                    <div>时间：{{j.startTime&&j.startTime.slice(0,10)}}<span v-if="j.endTime">~{{j.endTime&&j.endTime.slice(0,10)}}</span></div>
                  </div>
                  <img :src="j.picture" alt="">
                  <p>{{ j.title }}</p>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- <div class="flex-row case-list">
          <div class="s-item">
            <img src="@/assets/images/business/case1.png" alt="">
            <div class="item-bottom">金融大数据应用能力提升高级研修班</div>
          </div>
          <div class="l-item">
            <img src="@/assets/images/business/case2.png" alt="">
            <div class="item-bottom">产业转型升级与园区创新发展研修班</div>
          </div>
          <div class="s-item">
            <img src="@/assets/images/business/case3.png" alt="">
            <div class="item-bottom">日本令和元年“百年传承与工匠精神”观察与访学</div>
          </div>
          <div style="margin-top:-110px" class="m-item">
            <img src="@/assets/images/business/case4.png" alt="">
            <div class="item-bottom">海外访学-参观柏林勃兰登堡门</div>
          </div>
          <div style="margin-top:25px" class="l-item">
            <img src="@/assets/images/business/case5.png" alt="">
            <div class="item-top">全球CEO大会</div>
          </div>
          <div style="margin-top:-110px" class="m-item">
            <img src="@/assets/images/business/case6.png" alt="">
            <div class="item-bottom">新时代招商引资实务及招商干部能力提升高级研修班</div>
          </div>
          <div style="margin-top:-150px" class="s-item">
            <img src="@/assets/images/business/case7.png" alt="">
            <div class="item-top">企业转型与创新融合发展高级研修班</div>
          </div>
          <div style="margin-top:-150px" class="s-item">
            <img src="@/assets/images/business/case8.png" alt="">
            <div class="item-top">园区访学</div>
          </div>

        </div> -->
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import "@/assets/css/train.css";
import Header from './Header'
import Footer from './Footer'
export default {
  name: "Train",
  components:{
    Header,Footer
  },
  data() {
    return {
      currentCase:0,
      caseList: [
        [
          {
            img:
              require('@/assets/images/business/案例1.png'),member:'湖北省当阳市民营企业家',scale:'38人',date:'2019年7月21日-27日',
              word:"湖北当阳民营企业家国情省情市情研修培训班"
          },
          { img: require('@/assets/images/business/案例2.png'),member:'河北邢台经济开发区政府干部',scale:'58人',date:'2019年7月15日-19日',word:"河北邢台经济开发区招商领导干部能力提升高级研修班"},
          { img: require('@/assets/images/business/案例3.png'),member:'湖南衡阳党校中青年干部',scale:'50人',date:'2019年5月10日-14日',word:"湖南衡阳党校中青年干部上海异地教学研修班"},
          { img: require('@/assets/images/business/案例4.png'),member:'四川省彭州市政府干部',scale:'40人',date:'2019年5月5日-10日',word:"彭州市专业招商干部人才培训课程"},
          { img: require('@/assets/images/business/案例5.png'),member:'芜湖县政府招商干部',scale:'40人',date:'2019年5月13日-15日',word:"芜湖县招商引资实务及干部能力提升高级研修班"},
          { img: require('@/assets/images/business/案例6.png'),member:'全国各地企业家',scale:'10人',date:'2019年3月31日-4月6日',word:"汉诺威工业博览会暨德国之翼”工业4.0“研修班" }
        ],
        [
          { img: require('@/assets/images/business/案例7.png'),member:'黑龙江双鸭山市八个区县、双鸭山市经开区、商务局、长三办、深圳办等地招商干部',scale:'40人',date:'2018年11月9日-13日', word: "新时代招商引资实务及招商干部能力提升高级研修" },
          { img: require('@/assets/images/business/案例8.png'),member:'上海市浦东新区上钢商会企业家',scale:'22人',date:'2018年10月24日-28日', word: "上钢商会名企访学之旅-贵州站" },
          { img: require('@/assets/images/business/案例9.png'),member:'浦东新区工商联企业家',scale:'50人',date:'2019年4月29日', word: "浦东新区工商联信息综合能力建设项目基层商会专场培训" },
          { img: require('@/assets/images/business/案例10.png'),member:'鞍山市立山区、衡水市冀州区企业家',scale:'50人',date:'2018年6月25日-29日', word: "产业转型升级与创新融合发展（立山-冀州）高级研修班" },
        ]
      ],
      };
  },
  created(){
  },
  mounted() {
    var wow = new this.$wow.WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 200,
      mobile: false,
      live: true
    });
    wow.init();
    this.getCaseList()
  },
  methods:{
    prevLesson(){
      this.$refs.carouselLesson.prev()
    },
    nextLesson(){
      this.$refs.carouselLesson.next()
    },
    prevCase(){
      this.$refs.carouselCase.prev()
    },
    nextCase(){
      this.$refs.carouselCase.next()
    },
    getCaseList(){//培训案例
      this.Axios.post(`/api/index/cms/activity/list`,{type:'培训案例'}).then(res=>{
        this.caseList = this.$lodash.chunk(res.data.data, 6);
      })
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Train.vue